export default __webpack_public_path__ + "static/media/lexus.c58361e9.svg";